import React from "react";

const BuildPc = () => {
  return <div>In progress...</div>;
};

export default BuildPc;
